// TODO(@fabric-ui) - rule not in this repo
// /* eslint-disable fabric-ui/no-import-meta-env */

// Runtime env vars injected by envVars.js (loaded before the app in index.html).
// The canonical key list is declared in client/src/types/global.d.ts (ImportMetaEnv).
type RuntimeEnv = Record<string, string | undefined>;

// eslint-disable-next-line no-underscore-dangle, @typescript-eslint/naming-convention
declare const __ENV__: RuntimeEnv | undefined;

// Build-time env provided by Vite's import.meta.env.
// The full ImportMetaEnv type lives in the client package; here we only need the
// string-keyed shape so we can iterate and merge. Deliberately not augmenting the
// global `ImportMeta` interface here (a local cast instead) - consumers resolving
// this package from source (fabric-src) also see the client's own global
// ImportMetaEnv augmentation, and TS requires merged interface members to have the
// exact same type, not just a structurally-compatible one.
interface BuildEnv {
  [key: string]: string | boolean | undefined;
}

// Runtime env injection: envVars.js (loaded in index.html) sets globalThis.__ENV__.
// In local dev, __ENV__ is absent/empty, so we fall back to import.meta.env.
const getRuntimeEnv = (): RuntimeEnv => {
  if (typeof __ENV__ !== 'object' || __ENV__ === null) {
    return {};
  }
  return __ENV__;
};

// Merge env variables from all sources.
// - __ENV__ (runtime): wins for VITE_* keys (set per-domain by envVars.js)
// - import.meta.env (build-time): always wins for non-VITE keys (MODE, DEV, etc.)
//   and provides fallback for VITE_* keys not present at runtime (local dev)
const getProjectEnvVariables = (): { envVariables: Record<string, string> } => {
  const envVariables: Record<string, string> = {};
  const runtimeEnv = getRuntimeEnv();
  const buildEnv = (import.meta as unknown as { env: BuildEnv }).env;

  // Collect all keys from both sources
  const allKeys = new Set([...Object.keys(buildEnv), ...Object.keys(runtimeEnv)]);
  allKeys.forEach(key => {
    // Runtime injection only applies to VITE_* keys; build-time-only keys
    // (MODE, DEV, PROD, SSR, BASE_URL, STORYBOOK) must not be overridden.
    const runtimeVal = runtimeEnv[key];
    const buildVal = buildEnv[key];
    if (key.startsWith('VITE_') && runtimeVal !== undefined) {
      envVariables[key] = runtimeVal;
    } else if (buildVal !== undefined) {
      envVariables[key] = String(buildVal);
    }
  });

  return { envVariables };
};

export const { envVariables } = getProjectEnvVariables();
